import { SPOT_STATUS, BOOKING_STATUS, TIER } from "@/lib/shariti";

export function StatusBadge({ status, size = "sm", testId }) {
  const meta = SPOT_STATUS[status] || { label: status, cls: "bg-gray-100 text-gray-700 border-gray-200", icon: null };
  const Icon = meta.icon;
  const pad =
    size === "xs" ? "px-1.5 py-0.5 text-[9px] gap-1"
    : size === "sm" ? "px-2.5 py-1 text-[11px] gap-1.5"
    : "px-3 py-1.5 text-xs gap-1.5";
  const iconCls = size === "xs" ? "h-2.5 w-2.5" : "h-3 w-3";
  return (
    <span data-testid={testId || `status-${status}`}
      className={`inline-flex items-center rounded-full border font-semibold ${pad} ${meta.cls}`}>
      {Icon && <Icon className={`${iconCls} shrink-0`} />}
      {meta.label}
    </span>
  );
}

export function BookingBadge({ status, testId }) {
  const meta = BOOKING_STATUS[status] || { label: status, dot: "#999", cls: "bg-gray-100 text-gray-700 border-gray-200" };
  return (
    <span data-testid={testId || `booking-status-${status}`}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-bold ${meta.cls}`}>
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: meta.dot }} />
      {meta.label}
    </span>
  );
}

export function TierBadge({ tier, testId }) {
  if (!tier) return null;
  const meta = TIER[tier];
  return (
    <span title={meta?.desc} data-testid={testId || `tier-${tier}`}
      className={`inline-flex h-6 w-6 items-center justify-center rounded-full border text-xs font-extrabold ${meta?.cls}`}>
      {tier}
    </span>
  );
}
